export const SOLSCAN_URL = "https://solscan.io/account";
export const SOLSCAN_TX_URL = "https://solscan.io/tx";
export const DEVNET_CLUSTER = "cluster=devnet";
export const MAINNET_CLUSTER = "cluster=mainnet";
export const SOLSCAN_DEVNET = "?cluster=devnet";

export const RPC_ERROR = "rpc error";
export const SOLANA_NETWORK = "solanaNetwork";

export const BETA_URL = "https://beta.unique.vc/";

export const MAGIC_EDEN_API_URL = "https://api-mainnet.magiceden.dev/v2/";
